function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import request from '@/utils/request';
/**
 * 查询公司
 */
export function getCompanyListApi(str) {
  return request({
    url: "/admin/business/company/list/".concat(str ? str : ''),
    method: 'GET'
  });
}

/**
 * 模糊查询公司
 */
export function getCompanyOptionsApi(par) {
  var data = _objectSpread(_objectSpread({}, par), {}, {
    status: 1
  });
  return request({
    url: "/admin/business/company/options",
    method: 'GET',
    params: data
  });
}

/**
 * 查询客户列表
 */
export function getCustomersApi(params) {
  return request({
    url: "/admin/customers",
    method: 'GET',
    params: params
  });
}

/**
 * 添加客户
 */
export function addCouponApi(data) {
  return request({
    url: "/admin/customers",
    method: 'POST',
    data: data
  });
}
/**
 * 删除客户
 */
export function DeleteCouponApi(id) {
  return request({
    url: "/admin/customers/".concat(id),
    method: 'DELETE'
  });
}
/**
 * 修改客户
 */
export function editCouponApi(data) {
  return request({
    url: "/admin/customers",
    method: 'PUT',
    data: data
  });
}

/**
 * 客户详情
 */
export function detailCouponApi(id) {
  return request({
    url: "/admin/customers/".concat(id),
    method: 'GET'
  });
}

/**
 * 商品分类
 * @param pram
 */
export function categoryApi(params) {
  return request({
    url: '/admin/category/list/tree',
    method: 'GET',
    params: params
  });
}

/**
 * 开发配置
 */
export function devConfigApi(customerNumber) {
  return request({
    url: "/admin/dev-config/".concat(customerNumber),
    method: 'GET'
  });
}

/**
 * 资金记录列表
 */
export function fundsRecordsApi(params) {
  return request({
    url: "/admin/funds-records/page-list",
    method: 'GET',
    params: params
  });
}
/**
 * 添加资金记录
 */
export function addFundsRecordsApi(data) {
  return request({
    url: "/admin/funds-records/add",
    method: 'POST',
    data: data
  });
}
/**
 * 资金记录详情
 */
export function fundsRecordsDetailApi(id) {
  return request({
    url: "/admin/funds-records/".concat(id),
    method: 'GET'
  });
}

/**
 * 更新开发配置
 */
export function updateDevApi(data) {
  return request({
    url: "/admin/dev-config",
    method: 'POST',
    data: data
  });
}

/**
 * 查询供应商
 */
export function getSupplierApi(params) {
  return request({
    url: "/admin/business/supplier/list",
    method: 'GET',
    params: params
  });
}

/**
 * 查询供应商商品
 */
export function getSupplieGoodsrApi(params) {
  return request({
    url: "/admin/customer-suppliers/products/for-new/".concat(params.supplierId),
    method: 'GET',
    params: params
  });
}

/**
 * 绑定供应商
 */
export function bindSupplierApi(data) {
  return request({
    url: "/admin/customer-suppliers/bind-supplier",
    method: 'POST',
    data: data
  });
}

/**
 * 编辑供应商
 */
export function updateSupplierApi(data) {
  return request({
    url: "/admin/customer-suppliers/bind-supplier/products/update",
    method: 'POST',
    data: data
  });
}

/**
 * 获取客户供应商绑定分页列表（客户产品配置---供应商绑定---分页查询接口）
 */
export function customerSuppliersApi(customerId) {
  return request({
    url: "/admin/customer-suppliers/page-list/".concat(customerId),
    method: 'GET'
  });
}

/**
 * 查询指定客户关联的商品列表（客户产品配置---产品列表---分页查询接口
 */
export function productsPageApi(params) {
  return request({
    url: "/admin/customer-suppliers/products/page",
    method: 'GET',
    params: params
  });
}

/**
 * 移除客户关联的商品(客户产品配置---产品列表中---移除商品
 */
export function deleteProductsApi(params) {
  return request({
    url: "/admin/customer-suppliers/products/remove",
    method: 'DELETE',
    params: params
  });
}

/**
 * 移除客户关联的供应商（客户产品配置---供应商绑定---移除接口）
 */
export function deleteSupplierApi(params) {
  return request({
    url: "/admin/customer-suppliers/bind-supplier/".concat(params.customerId, "/").concat(params.supplierId),
    method: 'DELETE'
  });
}

/**
 * 更新商品价格
 */
export function updatePriceApi(params) {
  return request({
    url: "/admin/customer-suppliers/product/price",
    method: 'PUT',
    params: params
  });
}

/**
 * 改价记录列表
 */
export function updatePriceRecordApi(params) {
  return request({
    url: "/admin/customer-suppliers",
    method: 'GET',
    params: params
  });
}

/**
 * 查询客户关联的供应商和商品列表（客户产品配置---供应商绑定---编辑回显数据接口
 */
export function getSupplierEditInfoApi(params) {
  return request({
    url: "/admin/customer-suppliers/products/edit/".concat(params.customerId, "/").concat(params.supplierId),
    method: 'GET'
  });
}

/**
 * 批量改价操作
 */
export function batchApi(data) {
  return request({
    url: "/admin/customer-suppliers/batch",
    method: 'POST',
    data: data
  });
}

/**
 * 获取商户
 */
export function getActiveCustomersApi() {
  return request({
    url: "/admin/customers/active-customers",
    method: 'GET'
  });
}

/**
 * 商品利率配置列表
 */
export function getRateListApi(params) {
  return request({
    url: "/admin/customer/rate/list",
    method: 'GET',
    params: params
  });
}

/**
 * 保存商品利率配置
 */
export function getRateEdit(data) {
  return request({
    url: "/admin/customer/rate/save",
    method: 'POST',
    data: data
  });
}